<template>
  <div class="referral-card" @click="emit('click')">
    <div class="referral-card__inner">
      <div class="flex flex-col z-[200] opacity-90 gap-2">
        <span class="font-medium">הזמינו חברים וקבלו 75₪</span>
        <span class="text-xs text-pretty pe-12">על כל עסק שיצטרף בהמלצתכם תקבלו שובר ביימי בשווי 75₪</span>
      </div>
      <img class="absolute w-20 rotate-45 -bottom-5 -left-5" src="../../../../assets/img/admin/referral-img.png" alt="" />
    </div>
  </div>
</template>

<script setup lang="ts">
const emit = defineEmits<{ click: [] }>();
</script>

<style scoped lang="scss">
/* Animated gradient-border invite-friends card (extracted from the mobile menu). */
.referral-card {
  position: relative;
  width: 100%;
  padding: 2px;
  border-radius: 14px;
  cursor: pointer;
  background: conic-gradient(
    from var(--referral-angle, 0deg),
    #8864ee,
    #ec4899,
    #f59e0b,
    #22c55e,
    #06b6d4,
    #8864ee
  );
  animation:
    referralSpin 4s linear infinite,
    referralFloat 3.2s ease-in-out infinite;
  box-shadow: 0 10px 24px rgba(136, 100, 238, 0.3);
}

@keyframes referralFloat {
  0%, 100% {
    transform: translateY(0);
    box-shadow: 0 10px 24px rgba(136, 100, 238, 0.3);
  }
  50% {
    transform: translateY(-6px);
    box-shadow: 0 16px 28px rgba(136, 100, 238, 0.35);
  }
}

.referral-card__inner {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 1rem;
  border-radius: 12px;
  background: #fff;
  overflow: hidden;
}

@property --referral-angle {
  syntax: '<angle>';
  initial-value: 0deg;
  inherits: false;
}

@keyframes referralSpin {
  to { --referral-angle: 360deg; }
}

/* Fallback for browsers without @property support — rotate a pseudo-element instead */
@supports not (background: conic-gradient(from 0deg, red, blue)) {
  .referral-card {
    background: transparent;
    animation: none;
  }
  .referral-card::before {
    content: '';
    position: absolute;
    inset: -50%;
    background: conic-gradient(#8864ee, #ec4899, #f59e0b, #22c55e, #06b6d4, #8864ee);
    animation: referralSpinFallback 4s linear infinite;
    z-index: 0;
  }
  .referral-card__inner {
    position: relative;
    z-index: 1;
  }
}

@keyframes referralSpinFallback {
  to { transform: rotate(360deg); }
}
</style>
